import { render, staticRenderFns } from "./payment-channel.vue?vue&type=template&id=313116ee&scoped=true"
import script from "./payment-channel.vue?vue&type=script&lang=js"
export * from "./payment-channel.vue?vue&type=script&lang=js"
import style0 from "./payment-channel.vue?vue&type=style&index=0&id=313116ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313116ee",
  null
  
)

export default component.exports